import { Avatar, Button } from "@mui/material";
import PlusIcon from "@mui/icons-material/Add";
import { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import userAvatar from "../../../assets/images/userAvatar.png";
import { toBase64 } from "../../../utils/documentUtils";
import { DocumentItemType } from "../types";

const UploadDriverAvatar = ({
  name,
  pendingProfilePhoto,
}: {
  name?: string;
  pendingProfilePhoto?: DocumentItemType;
}) => {
  const { t } = useTranslation();
  const [preview, setPreview] = useState<string | null>(null);
  const { setValue, control, register } = useFormContext();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = await toBase64(file);
      setPreview(imageUrl);
      const documentName = name || pendingProfilePhoto?.name;

      const fileObj = {
        name: documentName,
        fileName: file.name,
        ext: file?.name.split(".")?.pop()?.toLowerCase(),
        image: imageUrl?.toString().split(",")[1],
        size: file.size,
      };
      setValue(documentName as string, fileObj);
    }
  };

  useEffect(() => {
    if (pendingProfilePhoto?.url) {
      setPreview(pendingProfilePhoto.url);
    }
  }, [pendingProfilePhoto]);

  return (
    <div style={{ position: "relative" }}>
      <Avatar src={preview ?? userAvatar} sx={{ width: 100, height: 100 }} />
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        {...register("avatar")}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <label htmlFor="avatar-upload">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => fileInputRef?.current?.click()}
          data-testid="upload-driver-avatar"
          startIcon={
            <PlusIcon
              sx={{
                color: "red",
                marginLeft: 1,
              }}
            />
          }
          sx={{
            bgcolor: "#fff",
            minWidth: 120,
            bottom: -12,
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
            "&:hover": {
              backgroundColor: "transparent !important",
              borderColor: "inherit !important",
              boxShadow: "none !important",
            },
          }}
        >
          {t("fleet_mgt_drivers_add_driver_photo_cta")}
        </Button>
      </label>
    </div>
  );
};

export default UploadDriverAvatar;
